import ObjectUtil from '@core/util/object';

const setKillSwitchUsingExperimentation = async (recipeId, ksName, properties, expSdk) => {
  const killSwitch = ObjectUtil.getChildProperty(properties, `${ksName}`);
  if (killSwitch) {
    const isRecipeSelected = await expSdk.isRecipeSelected(recipeId);
    ObjectUtil.setChildProperty(!!isRecipeSelected, `${ksName}`, properties);
  }
};

const checkExperimentation = async (recipeId, ksName, properties, expSdk) => {
  const isRecipeSelected = await expSdk.isRecipeSelected(recipeId);
  ObjectUtil.setChildProperty(!!isRecipeSelected, `${ksName}`, properties);
};

const checkExperimentationRecipeIds = async (recipeIds, ksName, properties, expSdk) => {
  const selectedRecipes = await expSdk.getSelectedRecipesForExperiment(recipeIds);
  if (selectedRecipes.length) {
    ObjectUtil.setChildProperty(true, `${ksName}`, properties);
  }
};

export { setKillSwitchUsingExperimentation, checkExperimentation, checkExperimentationRecipeIds };
